export default __webpack_public_path__ + "static/media/sub_page_directions.956d7c89.svg";